const translations = {
  "en": {
    "Back": "Back",
    "Confirm": "Confirm"
  },
  "zh-tw": {
    "Back": "返回",
    "Confirm": "確認"
  }
};

export default translations;
